import React from "react";
import styled from "styled-components";
import { CompassParagraph } from "../common/styledComponents";
import { BadgeStatus } from "../../types/StatusBadgeType";
import { statusBadgeColors } from "../../styles";

const StatusBadgeContainer = styled.div<{ bg: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;
  border-radius: 6px;
  padding: 6px 0px;
  background-color: ${({ bg }): string => bg};
`;

export const BADGE_STATUSES: BadgeStatus[] = [
  "Planned",
  "In progress",
  "Complete",
  "Stuck",
];

export const StatusBadge = ({
  status,
  customText,
}: StatusBadgeProps): JSX.Element => {
  return (
    <StatusBadgeContainer bg={statusBadgeColors[status].bg}>
      <CompassParagraph
        color={statusBadgeColors[status].text}
        fontSize={12}
        mr={1}
        bold={true}
      >
        {customText || status}
      </CompassParagraph>
    </StatusBadgeContainer>
  );
};

export const getStatusBadgeOption = (
  status: BadgeStatus,
  customText: string | undefined = undefined
): JSX.Element => {
  return <StatusBadge status={status} customText={customText} />;
};

export type StatusBadgeProps = {
  status: BadgeStatus;
  customText?: string;
};
